module.exports = __webpack_public_path__ + "img/mi-check_box_outline_blank--sharp.d76e2483.svg";